import * as React from "react";

function cn(...classes: Array<string | undefined | false | null>) {
  return classes.filter(Boolean).join(" ");
}

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "md" | "icon";
}

const baseClasses =
  "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";

const variants: Record<string, string> = {
  default:
    "bg-gradient-to-b from-[#fce96a] to-[#e3a008] text-black hover:from-yellow-500 hover:to-yellow-400",
  outline:
    "border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 shadow-sm",
  ghost: "text-gray-600 hover:bg-gray-100",
};

const sizes: Record<string, string> = {
  sm: "h-8 px-3 text-xs",
  md: "h-10 px-4",
  icon: "h-9 w-9",
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "md", ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          baseClasses,
          variants[variant],
          sizes[size],
          "focus-visible:ring-gold focus-visible:ring-offset-white",
          className,
        )}
        {...props}
      />
    );
  },
);

Button.displayName = "Button";

export { Button };

